import OrganizationService from "../services/OrganizationService"

// Namespaced
export const namespaced = true;

export const state = {
  accountOrganizations: []
};
export const mutations = {
  UPDATE_ACCOUNT_ORGANIZATIONS(state, accountOrganizations) {
    state.accountOrganizations = accountOrganizations;
  }
};
export const actions = {
  myAccount({ commit }) {
    OrganizationService.getAccountOrganizations().then(res => {
      commit("UPDATE_ACCOUNT_ORGANIZATIONS", res.data);
    });
  }
};
export const getters = {};
